import { memo } from 'react';

import { PrivateAssetBoardMembershipUpdateTasksPanel } from '~/components/AssetBoardMembershipUpdateTasks/PrivateAssetBoardMembershipUpdateTasksPanel';
import { PrivateAssetCustomFieldValueUpdateTasksPanel } from '~/components/AssetCustomFieldValueUpdateTasks/PrivateAssetCustomFieldValueUpdateTasksPanel';
import { PrivateTranscriptEditingTasksListener } from '~/components/AssetModalV2/Content/Panel/Transcript/PrivateTranscriptEditingTasksListener';
import { PrivateAssetTaggingTasksPanel } from '~/components/AssetTaggingTasks/PrivateAssetTaggingTasksPanel';
import { PrivateAssetTransformationTasksListener } from '~/components/AssetTransformationTasks/PrivateAssetTransformationTasksListener';
import { PrivateCaptionVideoTasksPanel } from '~/components/CaptionVideoTasks/PrivateCaptionVideoTasksPanel';
import { PrivateDeleteBoardTasksPanel } from '~/components/DeleteBoardTasks/PrivateDeleteBoardTasksPanel';
import { PrivateDeleteLibraryTasksPanel } from '~/components/DeleteLibraryTasks/PrivateDeleteLibraryTasksPanel';
import { PrivateDuplicateAssetTasksPanel } from '~/components/DuplicateAssetTasks/PrivateDuplicateAssetTasksPanel';
import { PrivateDuplicateBoardTasksPanel } from '~/components/DuplicateBoardTasks/PrivateDuplicateBoardTasksPanel';
import { PrivateRestoreAssetTasksPanel } from '~/components/RestoreAssetTasks/PrivateRestoreAssetTasksPanel';
import { PrivateRestoreBoardTasksPanel } from '~/components/RestoreBoardTasks/PrivateRestoreBoardTasksPanel';
import { PrivateRestoreLibraryTasksPanel } from '~/components/RestoreLibraryTasks/PrivateRestoreLibraryTasksPanel';
import { PrivateVideoClipTasksPanel } from '~/components/VideoClipTasks/PrivateVideoClipTasksPanel';
import { WorkspaceActivityContainer } from '~/components/WorkspaceActivityContainer';
import { PrivateZippingTasksPanel } from '~/components/ZippingTasks/PrivateZippingTasksPanel';

export const PrivateWorkspaceActivityContainer = memo(() => {
  return (
    <WorkspaceActivityContainer>
      <PrivateAssetTransformationTasksListener />
      <PrivateVideoClipTasksPanel />
      <PrivateCaptionVideoTasksPanel />
      <PrivateZippingTasksPanel />
      <PrivateAssetTaggingTasksPanel />
      <PrivateAssetCustomFieldValueUpdateTasksPanel />
      <PrivateAssetBoardMembershipUpdateTasksPanel />
      <PrivateRestoreAssetTasksPanel />
      <PrivateRestoreBoardTasksPanel />
      <PrivateRestoreLibraryTasksPanel />
      <PrivateDuplicateBoardTasksPanel />
      <PrivateDuplicateAssetTasksPanel />
      <PrivateDeleteBoardTasksPanel />
      <PrivateDeleteLibraryTasksPanel />
      <PrivateTranscriptEditingTasksListener />
    </WorkspaceActivityContainer>
  );
});

PrivateWorkspaceActivityContainer.displayName = 'PrivateWorkspaceActivityContainer';
